import { render, staticRenderFns } from "./PivotTable.vue?vue&type=template&id=5b944b0c&scoped=true&"
import script from "./PivotTable.vue?vue&type=script&lang=ts&"
export * from "./PivotTable.vue?vue&type=script&lang=ts&"
import style0 from "./PivotTable.vue?vue&type=style&index=0&id=5b944b0c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b944b0c",
  null
  
)

export default component.exports